var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "400",
      "title": `${_vm.openedVehicle ? '编辑' : '新增'}车辆`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "车牌",
      "prop": "plate"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入车牌..."
    },
    model: {
      value: _vm.formItem.plate,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "plate", $$v);
      },
      expression: "formItem.plate"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "核定载重量（吨）",
      "prop": "capacity"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 0,
      "placeholder": "输入核定载重量..."
    },
    model: {
      value: _vm.formItem.capacity,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "capacity", $$v);
      },
      expression: "formItem.capacity"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "默认司机",
      "prop": "defaultDriver"
    }
  }, [_c('Select', {
    model: {
      value: _vm.formItem.defaultDriver,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "defaultDriver", $$v);
      },
      expression: "formItem.defaultDriver"
    }
  }, _vm._l(_vm.driverList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "默认工厂",
      "prop": "factory"
    }
  }, [_c('Select', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: _vm.formItem.factory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "factory", $$v);
      },
      expression: "formItem.factory"
    }
  }, _vm._l(_vm.factoryList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('div', {
    staticStyle: {
      "margin": "12px 0"
    }
  }, [_vm._l(_vm.formItem.storageSection, function (item, index) {
    return _c('Row', {
      key: index,
      attrs: {
        "gutter": 16
      }
    }, [_c('Col', {
      attrs: {
        "span": "12"
      }
    }, [_c('FormItem', {
      attrs: {
        "label": `仓位 ${index + 1}`,
        "prop": `storageSection[${index}].name`,
        "rules": {
          required: true,
          message: '请输入仓位名',
          trigger: 'blur'
        }
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "例：前仓、中仓、后仓、全仓"
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    })], 1)], 1), _c('Col', {
      attrs: {
        "span": "8"
      }
    }, [_c('FormItem', {
      attrs: {
        "label": "容量（吨）",
        "prop": `storageSection[${index}].capacity`,
        "rules": {
          required: true,
          type: 'number',
          message: '请输入容量',
          trigger: 'blur'
        }
      }
    }, [_c('InputNumber', {
      attrs: {
        "min": 0,
        "placeholder": "该仓位的容量..."
      },
      model: {
        value: item.capacity,
        callback: function ($$v) {
          _vm.$set(item, "capacity", $$v);
        },
        expression: "item.capacity"
      }
    })], 1)], 1), _c('Col', {
      attrs: {
        "span": "4"
      }
    }, [index !== 0 ? _c('Button', {
      staticStyle: {
        "margin-top": "22px"
      },
      on: {
        "click": function ($event) {
          return _vm.removeStorageSection(index);
        }
      }
    }, [_vm._v("删除")]) : _vm._e()], 1)], 1);
  }), _c('Button', {
    attrs: {
      "type": "dashed",
      "icon": "md-add"
    },
    on: {
      "click": _vm.addStorageSection
    }
  }, [_vm._v("增加仓位")])], 2), _c('FormItem', {
    attrs: {
      "label": "禁用",
      "prop": "invalid"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-color": "#ff4949"
    },
    on: {
      "on-change": _vm.changeInvalid
    },
    model: {
      value: _vm.isInvalid,
      callback: function ($$v) {
        _vm.isInvalid = $$v;
      },
      expression: "isInvalid"
    }
  })], 1), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }